import React from 'react';
import './FloatingHeader.css';
import mapleeLogo from '../assets/logo.svg'; // Rename uploaded logo to maplee-logo.png and put in /src/assets

const FloatingHeader = () => {
  return (
    <header className="floating-header">
      <a href="https://maplee.ca" className="back-link">Back to store</a>
      <div className="center-logo">
        <a href="https://maplee.ca">
          <img src={mapleeLogo} alt="Maplee Logo" />
        </a>
      </div>
      <div className="spacer" /> {/* To balance flex for center alignment */}
    </header>
  );
};

export default FloatingHeader;